/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Display_Name_LabelInputs */

const en_new_project_display_name_label = /** @type {(inputs: New_Project_Display_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display Name`)
};

const fr_new_project_display_name_label = /** @type {(inputs: New_Project_Display_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom d'affichage`)
};

const de_new_project_display_name_label = /** @type {(inputs: New_Project_Display_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzeigename`)
};

const it_new_project_display_name_label = /** @type {(inputs: New_Project_Display_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome da visualizzare`)
};

const ru_new_project_display_name_label = /** @type {(inputs: New_Project_Display_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отображаемое имя`)
};

const es_new_project_display_name_label = /** @type {(inputs: New_Project_Display_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre para mostrar`)
};

const zh_cn2_new_project_display_name_label = /** @type {(inputs: New_Project_Display_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示名称`)
};

const ja_new_project_display_name_label = /** @type {(inputs: New_Project_Display_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示名`)
};

const hi_new_project_display_name_label = /** @type {(inputs: New_Project_Display_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रदर्शित होने वाला नाम`)
};

const pt_pt2_new_project_display_name_label = /** @type {(inputs: New_Project_Display_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome de exibição`)
};

/**
* | output |
* | --- |
* | "Display Name" |
*
* @param {New_Project_Display_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_display_name_label = /** @type {((inputs?: New_Project_Display_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Display_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_display_name_label(inputs)
	if (locale === "de") return de_new_project_display_name_label(inputs)
	if (locale === "it") return it_new_project_display_name_label(inputs)
	if (locale === "ru") return ru_new_project_display_name_label(inputs)
	if (locale === "es") return es_new_project_display_name_label(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_display_name_label(inputs)
	if (locale === "ja") return ja_new_project_display_name_label(inputs)
	if (locale === "hi") return hi_new_project_display_name_label(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_display_name_label(inputs)
	return en_new_project_display_name_label(inputs)
});